<template>
<!--  <img alt="Vue logo" src="./assets/logo.png">-->
  <TgLogin msg="Welcome to Your Vue.js App"/>
</template>

<script>
import TgLogin from './components/TgLogin.vue'

export default {
  name: 'App',
  components: {
    TgLogin
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
